import { render, staticRenderFns } from "./customerComplaint.vue?vue&type=template&id=63df9af1"
import script from "./customerComplaint.ts?vue&type=script&lang=js&external"
export * from "./customerComplaint.ts?vue&type=script&lang=js&external"
import style0 from "./customerComplaint.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports